import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AdminGuard from "../components/AdminGuard";
import AdminLayout from "../components/AdminLayout";
import { useAdminSession } from "../components/AdminSessionContext";
import MemberForm, { type MemberFormPayload } from "../components/MemberForm";
import { supabase } from "@/lib/supabase";

function CreateContent() {
  const navigate = useNavigate();
  const { username } = useAdminSession();
  const [done, setDone] = useState("");

  const handleSubmit = async (payload: MemberFormPayload) => {
    const { error } = await supabase
      .from("match_profiles")
      .insert({ ...payload, status: "pending", created_by_name: username || null });
    if (error) throw error;
    setDone(payload.name ? String(payload.name) : "");
    window.setTimeout(() => navigate("/admin"), 900);
  };

  if (done) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 rounded-lg border border-background-200 bg-background-50 px-6 py-20 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-checkbox-circle-line text-2xl"></i>
        </span>
        <div>
          <p className="text-sm font-medium text-foreground-900">已成功添加会员「{done}」</p>
          <p className="mt-1 text-xs text-foreground-500">正在返回会员列表…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            手动添加会员
          </h1>
          <p className="mt-1 text-sm text-foreground-500">
            逐项填写会员资料，可上传照片，保存后立即进入会员列表
          </p>
        </div>
        <Link
          to="/admin"
          className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-arrow-left-line"></i>
          返回列表
        </Link>
      </div>

      <MemberForm
        submitLabel="添加会员"
        submittingLabel="正在添加…"
        cancelLabel="取消"
        showPasteImport
        onCancel={() => navigate("/admin")}
        onSubmit={handleSubmit}
      />
    </div>
  );
}

export default function AdminMemberNew() {
  return (
    <AdminGuard allow={["admin", "matchmaker"]}>
      <AdminLayout>
        <CreateContent />
      </AdminLayout>
    </AdminGuard>
  );
}